// 受注の「作業曜日・時間」（日常清掃・管理員業務の人数分、ラウンドプラスの固定清掃）の新しい形
//
// 新しい形（曜日ごと）：契約詳細入力画面の行と同じで、1行＝1人。曜日ごとに勤務形態・開始・終了・実働を持つ
//   { days: { 月: { weekDetail: ['毎週'], startTime: '8:00', endTime: '12:00', hours: '4' }, 火: {…}, …（7曜日のキーを最初から持つ）},
//     workDays: ['月', '水'] }   ← 勤務のある曜日。古い形を読む所（要約の文・契約書の曜日の数など）がそのまま動くように常に合わせておく
//   勤務が無い曜日は weekDetail が空
// 以前の形：{ workDays, weekDetail: { 月: ['毎週'] }（さらに古いものは配列）, startTime, endTime, hours, breakHour, breakMinutes }
//   行に時間が1組しか無く、曜日ごとに時間を変えられない
// 過去の受注はそのまま（形を変えない）。見積から受注を作るときだけ新しい形にする
import { WEEKS } from '@libs/constants'
import * as utils from '@libs/utils'

export { WEEKS }

/**
 * 曜日ごとの形か
 */
export function isDaysRemark(remark) {
  return !!remark && !!remark.days && typeof remark.days === 'object' && !Array.isArray(remark.days)
}

/**
 * 曜日1つ分の空の欄
 */
export function blankDay() {
  return { weekDetail: [], startTime: '', endTime: '', hours: '' }
}

/**
 * 新しい形の空の1行（7曜日のキーを最初から持つ）
 */
export function blankDaysRemark() {
  const days = {}
  for (const w of WEEKS) {
    days[w] = blankDay()
  }
  return { days, workDays: [] }
}

/**
 * 曜日に勤務があるか（勤務形態が1つでもある）
 */
export function isDayOn(remark, w) {
  const day = remark.days && remark.days[w]
  return !!day && Array.isArray(day.weekDetail) && day.weekDetail.length > 0
}

/**
 * workDays（勤務のある曜日）を days に合わせる
 */
export function syncWorkDays(remark) {
  remark.workDays = WEEKS.filter(w => isDayOn(remark, w))
  return remark
}

/**
 * 勤務のある曜日の一覧（曜日順）
 * @returns [{ week: '月', weekDetail: ['毎週'], startTime, endTime, hours }]
 */
export function daysOf(remark) {
  return WEEKS.filter(w => isDayOn(remark, w)).map(w => ({ week: w, ...remark.days[w] }))
}

/**
 * 時間帯から実働を出す（契約詳細入力画面と同じ。6時間を超えれば休憩1時間を引く）
 */
export function hoursFromTimes(start, end) {
  let hours = utils.getHours(start, end)
  if (hours > 6) {
    hours--
  }
  return hours > 0 ? String(hours) : ''
}

/**
 * 見積の作業曜日・時間の1行（曜日が複数で時間は1組）→ 新しい形（選んだ曜日ぜんぶに同じ時間）
 * @param {Object} r 見積の行 { week: ['月','水'], weekDetail: [['毎週'], ['第1','第3']], start, end, breakHour, breakMinutes }
 * @param {Number} hours 実働（時間帯から休憩を引いたもの）
 */
export function daysRemarkFromEstimate(r, hours) {
  const remark = blankDaysRemark()
  const weeks = Array.isArray(r.week) ? r.week : []
  weeks.forEach((w, i) => {
    if (!remark.days[w]) {
      return
    }
    const detail = Array.isArray(r.weekDetail) && Array.isArray(r.weekDetail[i]) && r.weekDetail[i].length ? r.weekDetail[i].slice() : ['毎週']
    remark.days[w] = {
      weekDetail: detail,
      startTime: r.start || '',
      endTime: r.end || '',
      hours: hours === null || hours === undefined || hours === '' || !Number(hours) ? '' : String(Number(hours))
    }
  })
  return syncWorkDays(remark)
}

/**
 * 時間帯が同じ曜日をまとめた一覧（文に出すとき用。「月・水 8:00〜12:00」「火 9:00〜13:00」）
 * 曜日順に見て、同じ開始・終了のものを1つにまとめる
 * @returns [{ weeks: ['月','水'], startTime, endTime, hours }]
 */
export function groupDaysByTime(remark) {
  const groups = []
  for (const d of daysOf(remark)) {
    const g = groups.find(x => x.startTime === d.startTime && x.endTime === d.endTime)
    if (g) {
      g.weeks.push(d.week)
    } else {
      groups.push({ weeks: [d.week], startTime: d.startTime, endTime: d.endTime, hours: d.hours })
    }
  }
  return groups
}
